import { render } from "./FormsList.vue?vue&type=template&id=6e02ff94&scoped=true"
import script from "./FormsList.vue?vue&type=script&lang=js"
export * from "./FormsList.vue?vue&type=script&lang=js"

import "./FormsList.vue?vue&type=style&index=0&id=6e02ff94&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e02ff94"]])

export default __exports__